import formValidation from 'form-validation/dist/es6/core/Core';
import Bootstrap3 from 'form-validation/dist/es6/plugins/Bootstrap3';
import Recaptcha from 'form-validation/dist/es6/plugins/Recaptcha';
import Declarative from 'form-validation/dist/es6/plugins/Declarative';
import SubmitButton from 'form-validation/dist/es6/plugins/SubmitButton';
import Trigger from 'form-validation/dist/es6/plugins/Trigger';

let _internals = {
    init: function () {
        import(/* webpackChunkName: "intl-tel-input" */ 'intl-tel-input').then(function(module) {
            let elements = [].slice.call(document.querySelectorAll('[data-fv-int-phone-number]'));
            elements.forEach((ele) => {
                window.intlTelInputGlobals.loadUtils(ele.getAttribute('data-fv-int-phone-number___utils_path'));

                module.default(ele, {
                    autoPlaceholder: false,
                    allowDropdown: false,
                    defaultCountry: ele.getAttribute('data-fv-int-phone-number___default-country'),
                    initialCountry: 'ru',
                    onlyCountries: ['ru'],
                    utilsScript: ele.getAttribute('data-fv-int-phone-number___utils_path'),
                });
            });
        });
    }
};

const intlTelInputValidator = function() {
    const messages = {
        'ru': {
            0: 'Недопустимый номер',
            1: 'Недопустимый код страны',
            2: 'Слишком короткий номер',
            3: 'Слишком длинный номер',
            4: 'Введен недопустимый номер',
        },
        'en': {
            0: 'Number not allowed',
            1: 'Invalid country code',
            2: 'Number is too short',
            3: 'Number is too long',
            4: 'Number is invalid'
        }
    };

    return {
        validate: function(input) {
            let iti = window.intlTelInputGlobals.getInstance(input.element);
            iti.setCountry("ru");

            let isValid = input.value === '' || iti.isValidNumber();
            let err = iti.getValidationError();

            let locale = input.element.getAttribute('data-fv-int-phone-number___locale');

            return {
                valid: isValid,
                message: messages[locale][err]
            };
        }
    };
};

export const initIntlTelInput = _internals.init;
export const intPhoneNumberValidator = intlTelInputValidator;
export const fv = function(form, options) {
    const core = formValidation(form, options);
    core.registerValidator('intPhoneNumber', intlTelInputValidator);
    return core;
};
export const BootstrapPlugin = Bootstrap3;
export const RecaptchaPlugin = Recaptcha;
export const DeclarativePlugin = Declarative;
export const SubmitButtonPlugin = SubmitButton;
export const TriggerPlugin = Trigger;
